// ── Keep screen awake while a Clock-In timer/stopwatch is running (Android) ──
// Wraps the custom KeepAwakePlugin (android/app/.../KeepAwakePlugin.java),
// which sets/clears FLAG_KEEP_SCREEN_ON on the Activity window. This only
// holds off the inactivity screen-timeout while the app is in the
// foreground — it does not survive backgrounding or a manual power-button
// lock, and neither of those is something an app is allowed to override.
import { registerPlugin, Capacitor } from '@capacitor/core';

const KeepAwake = registerPlugin('KeepAwake');
const isNative = Capacitor.isNativePlatform();

export async function enableKeepAwake() {
  if (!isNative) return;
  try { await KeepAwake.enable(); } catch { /* best-effort */ }
}

export async function disableKeepAwake() {
  if (!isNative) return;
  try { await KeepAwake.disable(); } catch { /* best-effort */ }
}
